import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { ISsoStore } from '../stores/SsoStore';

import { registerError } from '../util/ErrorUtil';

import ApiError from './ApiError';

export default class SalesFrontendRepository {
  public static API_BASE_URL_DEFAULT = '/sales-api';

  private static TIMEOUT = 30000;

  private httpClient: AxiosInstance;

  constructor(private ssoStore: ISsoStore) {
    this.httpClient = this.getAxiosInstance(SalesFrontendRepository.TIMEOUT);
  }

  public getAxiosInstance(timeout: number, responseType?: ResponseType): AxiosInstance {
    const config: AxiosRequestConfig = {
      baseURL: SalesFrontendRepository.API_BASE_URL_DEFAULT,
      timeout,
      responseType
    };

    return axios.create(config);
  }

  public getProductCurrentBalanceModalProps(productId: number, source: string, language: string): Promise<any> {
    return this.getRequest(
      `/total-service-charge/products/${productId}?origin=${source}&locale=${language}&shouldCheckPrivateBillProduct=false`,
      'product-current-balance'
    );
  }

  public handleError(promise: Promise<any>, requestName: string): Promise<any> {
    return promise.catch((res) => {
      if (res.response != null && res.response.status === 403) {
        this.ssoStore.openSsoFrame();
        throw new ApiError('Access denied');
      } else {
        let error = res;
        if (res.code === 'ECONNABORTED') {
          error = new Error(`Request ${requestName} timeout`);
        }
        if (res.response != null) {
          error = new Error(`Request ${requestName} failed with status code ${res.response.status}`);
        }

        console.error('Failure', error);
        registerError(error);
        throw new ApiError(`Received error from backend ${error}`);
      }
    });
  }

  public unwrapData(promise: Promise<AxiosResponse>): Promise<any> {
    return promise.then((request) => request.data.data);
  }

  public handleRequest(promise: Promise<AxiosResponse>, requestName: string): Promise<any> {
    return this.handleError(this.unwrapData(promise), requestName);
  }

  private getRequest(uri: string, requestName: string) {
    return this.handleRequest(this.httpClient.get(uri), requestName);
  }
}
